import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";

const queryKey = (id: string) => ["linear-content", id];

const useLinearContentQuery = (
  id: string,
  options?: {
    isEnabled?: boolean;
  },
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(id),
    queryFn: () => api.getLinearContent(id),
    enabled: options?.isEnabled,
  });
};

export default useLinearContentQuery;
